import { useEffect } from 'react';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import { GET_DRAFT_CURRENCIES } from '../constants/aryGraphqlSchemas';
import arySystemSettings from '../constants/arySystemSettings';
import { useShowCurrenciesContext } from '../contexts/ShowCurrenciesContextProvider';
import { useAryLazyQuery } from './useAryGraphql';
import useSystemSettingsContext from './useSystemSettingsContext';

function getCurrencyByCode(currencies, code) {
  if (!currencies || !currencies.length) return null;
  const desireCurrency = currencies.find((currency) => currency.code === code);
  return desireCurrency;
}

function getCurrencyByTitle(currencies, title) {
  if (!currencies || !currencies.length) return null;
  const desireCurrency = currencies.find(
    (currency) => currency.title === title
  );
  return desireCurrency;
}

const useShowCurrency = (branchId) => {
  const { t } = useFrameworkTranslation();
  const { systemSettings } = useSystemSettingsContext();
  const showCurrenciesContext = useShowCurrenciesContext();

  const [getDraftCurrencies, { data: draftCurrenciesQueryData }] =
    useAryLazyQuery({
      gqlConfig: GET_DRAFT_CURRENCIES,
      items: `
        code
        title
      `
    });

  useEffect(() => {
    if (branchId) {
      getDraftCurrencies(branchId);
    }
  }, [branchId]);

  function showCurrency({ code, title }) {
    if (code) {
      if (systemSettings[arySystemSettings.showCurrencyByTitle]) {
        return t(
          getCurrencyByCode(
            !!branchId && draftCurrenciesQueryData
              ? draftCurrenciesQueryData
              : showCurrenciesContext,
            code
          )?.title
        );
      }
      return code;
    }
    if (title) {
      if (systemSettings[arySystemSettings.showCurrencyByTitle]) {
        return t(title);
      }
      return getCurrencyByTitle(
        !!branchId && draftCurrenciesQueryData
          ? draftCurrenciesQueryData
          : showCurrenciesContext,
        title
      )?.code;
    }
    return null;
  }

  return showCurrency;
};

export default useShowCurrency;
